var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.21187L8.66617 3.01806C7.95717 2.38348 7.02575 2 6 2C3.79086 2 2 3.79086 2 6C2 8.99957 3.33975 11.212 5.03224 12.8501C6.75438 14.5169 8.77982 15.5183 9.88567 15.9794C9.96256 16.0114 10.0374 16.0114 10.1143 15.9794C11.2202 15.5183 13.2456 14.5169 14.9678 12.8501C16.6602 11.2119 18 8.99964 18 6.00004C18 3.7909 16.2091 2 14 2C12.9742 2 12.0428 2.38348 11.3338 3.01806L10 4.21187ZM10 1.52779C8.93849 0.577707 7.53671 0 6 0C2.68629 0 0 2.68629 0 6C0 13.3511 6.67146 16.8061 9.11601 17.8254C9.68546 18.0628 10.3145 18.0628 10.884 17.8254C13.3285 16.8061 20 13.3512 20 6.00005C20 2.68634 17.3137 0 14 0C12.4633 0 11.0615 0.577707 10 1.52779Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.bc1da931c9f51a5cf8807f7331dba184.svg";
export { ForwardRef as ReactComponent };